export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/redpoints.fbf09809.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};